export default __webpack_public_path__ + "static/media/hexapod3.ce63b2fb.png";